import { connect } from 'react-redux';
import { ProductSummary as DumbProductSummary } from 'app/components/product/ProductSummary';
import {
  passengerCountSelector,
  wheelchairSelectedSelector,
  notFulfilledProductDependenciesSelector,
} from 'app/store/selectors';
import { StoreState } from 'app/models/types';

const mapStateToProps = (state: StoreState) => ({
  passengerCount: passengerCountSelector(state),
  notFulfilledProductDependencies: notFulfilledProductDependenciesSelector(state),
  wheelchairsCount: wheelchairSelectedSelector(state),
});

export const ProductSummary = connect(mapStateToProps)(DumbProductSummary);
